import {  memo  , useCallback , useState} from 'react';
import ListItem from '@mui/material/ListItem';
import {Box} from '@mui/material';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import { useTranslation } from "react-i18next";

const MapListItemFlower = memo((props) => {
    const {flowers , selectFlower } = props;
    const [openDescriptionId , setOpenDescriptionId] = useState(null);
    const { t } = useTranslation();

    const nl2comma = useCallback((str) => {
        return str.replaceAll("¥/", "、");
    },[]);
    const canDisplayDescription = useCallback((flower) => {
        if(!flower){
            return false;
        }
        return flower.description !== '';
    },[]);

    const toggleOpenDescription  = (flowerId) => {
        if(openDescriptionId === flowerId){
            setOpenDescriptionId(null);
        }else{
            setOpenDescriptionId(flowerId);
        }
    }

    return (
        flowers.map((flower, index) => 
            <ListItem alignItems="flex-start" key={index}>
            <Card className={"flowerListItem"}>
                <Box sx={{display:'flex'}}>
                    <CardMedia
                        component="img"
                        sx={{ width: 140 }}
                        image={"/assets/images/descriptions/" + flower.path}
                    />
                    <Box sx={{ display: 'block'}}>
                    <CardContent sx={{ flex: '1 0 auto' }}>
                        <Typography component="div" variant="h5" className="title">
                            {flower.name}
                        </Typography>

                        <Typography variant="subtitle1" component="div" sx={{ color: 'text.secondary', overflowWrap: 'break-word' }}>
                        {t("nature.card.area")}：{nl2comma(flower.area)}
                        </Typography>
                        <Typography variant="subtitle1" component="div" sx={{ color: 'text.secondary' }}>
                        {t("nature.card.season")}：{flower.seasons.period}
                        </Typography> 
                    </CardContent>
                    </Box>
                </Box>
                {canDisplayDescription(flower.description) && openDescriptionId === flower.id?
                    <Box className='description' id={`description_${flower.id}`}>
                        {flower.description}
                    </Box>:<></>
                    }
                <Box className='btnWrap'>
                    <Button variant="contained" onClick={() => selectFlower(flower)} >
                        {t("common.btn_on_map")}
                    </Button>
                    {canDisplayDescription(flower.description)?
                    <Button variant="outlined" onClick={() => toggleOpenDescription(flower.id)} key={flower.id}>
                        {openDescriptionId === flower.id?<>{t("common.btn_close_detail")}</>:<>{t("common.btn_open_detail")}</>}
                    </Button>
                    :<></>
                    }
                </Box>
            </Card>
            </ListItem>
        )
    )
});
export default MapListItemFlower